import { useContext } from 'react';
import { UserEventsContext } from '../../contexts';
import { getLocalStorageObject, isLocalhost, setLocalStorageObject } from '../../lib';
const defaultLocalStorageKey = 'testData';
const experimentsTestData = {};
let outcomes = {}; //prevent multi-outcome
const saveOutcomes = () => {
    setLocalStorageObject('outcomes', outcomes);
};
const loadOutcomes = () => {
    outcomes = getLocalStorageObject('outcomes');
};
const mergeData = (data, log) => {
    const dataArray = [];
    for (const key in data) {
        dataArray.push(`${key}-${data[key]}`);
    }
    log === null || log === void 0 ? void 0 : log.info('MergeData', dataArray.join('|'));
    return dataArray.join('|');
};
const missingKeyError = new Error('Experiment Elements must have Keys');
const makeChildrenArray = (children) => {
    if (Array.isArray(children)) {
        return children;
    }
    else {
        return [children];
    }
};
const buildLocalStorageKey = (localStorageProp) => {
    return localStorageProp === true
        ? defaultLocalStorageKey
        : typeof localStorageProp === 'string'
            ? localStorageProp !== null && localStorageProp !== void 0 ? localStorageProp : defaultLocalStorageKey
            : '';
};
const calcTotalWeight = (childList) => {
    let totalWeight = 0;
    for (const child of childList) {
        totalWeight += child.props.weight;
    }
    return totalWeight;
};
const Experiments = (props) => {
    var _a, _b;
    const { name, children, testStarted, localStorageProp = true } = props;
    const userEventsConntext = useContext(UserEventsContext);
    const { userEvents } = userEventsConntext;
    loadOutcomes();
    const localStorageKey = buildLocalStorageKey(localStorageProp);
    const childList = makeChildrenArray(children);
    const totalWeight = calcTotalWeight(childList);
    const firstTime = outcomes[name] === undefined;
    let targetWeight = (_a = outcomes[name]) !== null && _a !== void 0 ? _a : Math.random() * totalWeight;
    outcomes[name] = targetWeight;
    saveOutcomes();
    for (const child of childList) {
        targetWeight -= child.props.weight;
        if (targetWeight > 0)
            continue;
        if (!child.key) {
            throw missingKeyError;
        }
        experimentsTestData[name] = (_b = child.key) === null || _b === void 0 ? void 0 : _b.toString();
        if (firstTime) {
            if (localStorageProp !== false) {
                localStorage.setItem(localStorageKey, mergeData(experimentsTestData));
            }
            if (!isLocalhost) {
                userEvents === null || userEvents === void 0 ? void 0 : userEvents.testStarted({});
                testStarted === null || testStarted === void 0 ? void 0 : testStarted();
            }
        }
        return child;
    }
    throw new Error('Experiment Choice Failed');
};
export default Experiments;
//# sourceMappingURL=Experiments.js.map